import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../../environments/environment';
import OpenReplay from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
import { StartOptions } from '@openreplay/tracker/dist/lib/main/app';
import { Utils } from '../utils';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpResponse,
} from '@angular/common/http';

type ReqRespType = {
  request: HttpRequest<any>,
  response: HttpResponse<any>
}

@Injectable({
  providedIn: 'root',
})
export class OpenReplayService {
  public tracker?: OpenReplay | null;
  private allowTracking = true;
  private env = environment;


  constructor(private zone: NgZone) {
    this.allowTracking = this.env.isOpenReplayEnabled && !!this.env.openReplayKey;
  }

  public startSession():void {
    
    if(this.isEnabled() && this.tracker == null){
      const defaultOptions = Utils.getOpenReplayDefaultSettings();
      const startOptions = Utils.getOpenReplayStartOptions();
      const trackAssistOptions = Utils.getOpenReplayTrackAssistsOptions();

      console.log('initialize Open Replay...');
      this.tracker = new OpenReplay(defaultOptions);
      
      console.log('initialize Open Replay TrackerAssits...');
      this.tracker.use(trackerAssist(trackAssistOptions));

      console.log('Start Open Replay...');
      this.tracker.start(startOptions);

      this.tracker.setMetadata('subdomain', window.location.hostname.split('.')[0]);
      this.tracker.setMetadata('env', this.env.name.toLowerCase());
    }
  }

  public isEnabled():boolean{
    if(this.allowTracking){
      return true;
    }
    return false;
  }


  public setUser(userID: number, userName: string, userEmail: string, claimMetadataID: number): void {
    if (this.tracker) {
      //this.tracker.setUserID(String(userID));
      this.tracker.setMetadata('userID', String(userID));
      this.tracker.setMetadata('userName', userName);
      this.tracker.setMetadata('userEmail', userEmail);
      this.tracker.setMetadata('userGroup', String(claimMetadataID));
    }
  }

  // used from the openReplayIntercaptor, duration is optinal
  sendEventToReplaySession(event: string, params: ReqRespType & { duration?: string }): void {
    const { request, response, duration } = params;
  
    const logEvent = (suffix: string, data: object) => {
      this.tracker?.event(`${event}[${suffix}]`, data);
    };
  
    logEvent("request", {
      method: request.method,
      url: request.url,
      params: request.params,
    });
  
    logEvent("response", {
      body: response.body,
      status: response.status,
      headers: response.headers,
      duration, // Include duration if available
    });
  }


  public getTracker(): OpenReplay | null{
    return this.tracker;
  }
}
